import { captureSession, getSessionBoundary, sessionSignal } from "./session";
import { guardResponse } from "./responseLifecycle";

export function isLocalDemoRequested(): boolean {
  return import.meta.env.DEV && ["localhost", "127.0.0.1"].includes(window.location.hostname)
    && new URLSearchParams(window.location.search).get("0424") === "1";
}
export function isDemoMode(): boolean {
  return getSessionBoundary().identity === "legacy" && isLocalDemoRequested();
}
export async function fetchDemoFixture(path: string, caller?: AbortSignal): Promise<Response> {
  if (!isDemoMode() || !/^\/demo-canned\/[a-z.-]+\.json$/.test(path)) throw new Error("DEMO_UNAVAILABLE");
  const session = captureSession();
  const signal = sessionSignal(caller);
  const response = guardResponse(await fetch(path, { cache: "no-cache", signal, credentials: "omit" }), signal);
  session.assertCurrent();
  return response;
}
